import { useState, useEffect } from 'react'
import { makeStyles, useTheme, useMediaQuery } from '@material-ui/core'
import PdpaNewBanner from './_PdpaNewBanner'
import PdpaSetting from './_PdpaSetting'

const useStyles = makeStyles((theme) => ({
  rootDesktop: {
    position: 'fixed',
    bottom: theme.spacing(1),
    left: 0,
    width: '100%',
    zIndex: theme.zIndex.modal,
    paddingBottom: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      zIndex: '13000',
      bottom:0,
      paddingBottom: 0,
    },
  },
  rootMobile: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    zIndex: theme.zIndex.modal,
    [theme.breakpoints.down('sm')]: {
      zIndex: '13000',
    }
  },
}))

const PdpaPopup = ({
  pdpaStates,
  setPdpa,
  isShowing,
  setShowing,
  editCookiesMode = false,
  setEditCookiesMode,
}) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))
  const isTablet = useMediaQuery(theme.breakpoints.only('sm'))
  const isDesktop = !isMobile && !isTablet
  const classes = useStyles()
  const [isSettingOpen, setSettingOpen] = useState(false) // if in editCookiesMode -> true
  const [switchStates, setSwitchStates] = useState({
    targeting: true,
    functionality: true,
    performance: true,
  }) // this is state of switches not actually using setting
  // on pdpaStates change
  useEffect(() => {
    if (pdpaStates.isSetPdpa) {
      setSwitchStates({
        targeting: pdpaStates.allowTargeting,
        functionality: pdpaStates.allowFunctionality,
        performance: pdpaStates.allowPerformance,
      })
    }
  }, [pdpaStates])

  useEffect(() => {
    setSettingOpen(editCookiesMode)
  }, [editCookiesMode])

  const handleSwitchChange = (e) => {
    setSwitchStates({ ...switchStates, [e.target.name]: e.target.checked })
  }

  const handleSaveSetting = () => {
    setPdpa(switchStates)
    setShowing(false)
    setEditCookiesMode(false)
  }

  const handleAcceptAll = () => {
    setPdpa({
      targeting: true,
      functionality: true,
      performance: true,
    })
    setShowing(false)
  }

  const handleEditCookiesClose = () => {
    setShowing(false)
    setEditCookiesMode(false)
  }

  const settingComponent = (
    <PdpaSetting
      isDesktop={isDesktop}
      switchStates={switchStates}
      handleSwitchChange={handleSwitchChange}
    />
  )

  if (!isShowing) return null
  return (
    <>
      <div
        className={
          isSettingOpen && !isDesktop ? classes.rootMobile : classes.rootDesktop
        }
      >
        <PdpaNewBanner
          isMobile={isMobile}
          isTablet={isTablet}
          settingComponent={settingComponent}
          handleSaveSetting={handleSaveSetting}
          handleAcceptAll={handleAcceptAll}
          editCookiesMode={editCookiesMode}
          handleEditCookiesClose={handleEditCookiesClose}
          setSettingOpen={setSettingOpen}
          isSettingOpen={isSettingOpen}
        />
      </div>
    </>
  )
}

export default PdpaPopup
